import React from "react";
import ContentLoader from "react-content-loader";

const BugDetailsContentLoader = () => {
  return <ContentLoader />;
};

export default BugDetailsContentLoader;
